<script>
import { mapActions } from 'vuex'
import utils from '@/utils'

const commonRules = {
  'required-field': {
    required: true,
    message: 'To pole jest wymagane.',
    trigger: 'blur'
  }
}

export default {
  name: 'user-address-edit',
  props: {
    initialAddress: {
      type: Object,
      required: true
    }
  },
  data () {
    var validateApi = (rule, value, callback, source, options) => {
      if (this.errors[ rule.field ]) {
        this.errors[ rule.field ].forEach(function (message) {
          callback(message)
        })
        delete this.errors[ rule.field ]
      } else {
        callback()
      }
    }

    return {
      address: { ...this.initialAddress },
      errors: [],
      formChanged: false,
      rules: {
        name: [
          { validator: validateApi, trigger: 'blur' }
        ],
        street: [
          commonRules[ 'required-field' ],
          { validator: validateApi, trigger: 'blur' }
        ],
        number: [
          { validator: validateApi, trigger: 'blur' }
        ],
        apartment: [
          { validator: validateApi, trigger: 'blur' }
        ],
        place: [
          commonRules[ 'required-field' ],
          { validator: validateApi, trigger: 'blur' }
        ],
        zip: [
          commonRules[ 'required-field' ],
          { validator: validateApi, trigger: 'blur' }
        ],
        taxNumber: [
          { validator: validateApi, trigger: 'blur' }
        ],
        phone: [
          { validator: validateApi, trigger: 'blur' }
        ]
      }
    }
  },
  updated () {
    this.formChanged = true
  },
  methods: {
    ...mapActions([
      'aMessageDisplay',
      'aAddressChange',
      'aAddressCreate'
    ]),
    handleSubmit (formName) {
      if (this.formChanged) {
        this.$refs[ formName ].validate((valid) => {
          if (valid) {
            let action = this[ formName ].addressId ? 'aAddressChange' : 'aAddressCreate'
            this[ action ](this[ formName ])
              .then(() => {
                this.$emit('update:visible', false)
              })
              .catch((err) => {
                this.errors = utils.keysToCamel(err.body)
                this.$refs[ formName ].validate()
                return false
              })
          } else {
            return false
          }
        })
      } else {
        this.$emit('update:visible', false)
      }
    },
    handleCancel (formName) {
      if (this.formChanged) {
        this.$confirm(
          'Czy na pewno chcesz porzucić wprowadzone zmiany?',
          'Uwaga',
          {
            confirmButtonText: 'Tak',
            cancelButtonText: 'Nie',
            type: 'warning'
          })
          .then(() => {
            this.$emit('update:visible', false)
          })
          .catch({})
      } else {
        this.$emit('update:visible', false)
      }
    }
  }
}
</script>

<template>
  <el-form
    ref="address"
    label-width="120px"
    size="small"
    :model="address"
    :rules="rules"
  >
    <el-form-item
      label="nazwa"
      prop="name"
    >
      <el-input
        placeholder="nazwa"
        v-model="address.name"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="ulica"
      prop="street"
    >
      <el-input
        placeholder="ul. ..."
        v-model="address.street"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="numer"
      prop="number"
    >
      <el-input
        placeholder="numer posesji"
        v-model="address.number"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="lokal"
      prop="apartment"
    >
      <el-input
        placeholder="nr lokalu"
        v-model="address.apartment"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="miejscowość"
      prop="place"
    >
      <el-input
        placeholder="miejscowość"
        v-model="address.place"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="kod"
      prop="zip"
    >
      <el-input
        placeholder="kod pocztowy"
        v-model="address.zip"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="NIP"
      prop="taxNumber"
    >
      <el-input
        placeholder="numer NIP"
        v-model="address.taxNumber"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="nr telefonu"
      prop="phone"
    >
      <el-input
        placeholder="+48..."
        type="email"
        v-model="address.phone"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <el-checkbox v-model="address.defaultShipment">Domyślny adres dostawy</el-checkbox>
    </el-form-item>
    <el-form-item>
      <el-checkbox v-model="address.invoiceBuyer">Adres nabywcy na fakturze (wymagany NIP)</el-checkbox>
    </el-form-item>
    <el-form-item>
      <el-checkbox v-model="address.invoiceRecipient">Adres odbiorcy na fakturze (opcjonalny)</el-checkbox>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        @click="handleSubmit('address')"
      >Zapisz</el-button>
      <el-button
        style="float: right; margin: .5rem 0;"
        @click="handleCancel('address')"
      >
        Anuluj
      </el-button>
    </el-form-item>
  </el-form>
</template>



// WEBPACK FOOTER //
// src/components/user-address-edit.vue